import { useDispatch, useSelector } from "react-redux";
import { useReportWidgetService } from "serviceHooks";
import { AppState } from "store";
import { setCachedChart } from "store/actions/cachedChartsActions";

function useChartsWithCache() {
  const dispatch = useDispatch();
  const reportWidgetService = useReportWidgetService();
  const cachedCharts = useSelector((state: AppState) => state.cachedCharts.charts);

  const getChartByFilter = async (apiKey: string, filter: object, cacheKey?: string) => {
    if (!cacheKey) {
      return await reportWidgetService.getChartWithFilter(apiKey, filter);
    }

    let chart = cachedCharts[cacheKey];

    if (!chart) {
      chart = { cacheKey };
      dispatch(setCachedChart(chart));
      const data = await reportWidgetService.getChartWithFilter(apiKey, filter);
      chart = { cacheKey, data };
      dispatch(setCachedChart(chart));
    }

    return chart.data;
  };

  return { getChartByFilter };
}

export default useChartsWithCache;
